import React, { useEffect, useState } from 'react';
import { useParams, Link } from "react-router-dom";

import enums from '../../../helpers/enums';
import images from '../../../helpers/images';
import appConfig from '../../../config/env';
import helpers from '../../../helpers/helpers';
import { httpRequest, httpAuthHeaders } from '../../../helpers/httpService';
import Swal from 'sweetalert2';
import Dropdown from 'react-bootstrap/Dropdown'
import Loader from '../../parts/Loader';
import SearchBar from '../../parts/SearchBar';
import Paginations from '../../parts/Paginations';
 
function DashboardAdmin (){
    const api_url = appConfig.apiUrl;
    const [event_list, setEvents] = useState([]);
    const [loading, setLoading] = useState(1);
    const [res_data, setResData] = useState([]);
    
    // Search
    const [search_key, setSearchKey] = useState('');
    const [search_filter, setFilter] = useState('title');
    const [tab, changeTab] = useState('my-events');

    useEffect(() => {
        getEvents()
    }, []);

    function getEvents() {
        //const params = ''
        const params = ''//'?per_page=2'
        const url = api_url + '/admin/events'+params;
        setLoading(1)

        sendRequest(url)
    }

    function changePage(page) {
        let params = 'page='+page
        //params += '&per_page=2'

        if(search_key!==''){
            params += '&' + search_filter+'='+search_key
        }

        const url = api_url + '/admin/events?'+params;

        setLoading(1)
        sendRequest(url)
    }

    function handleSearch(){
        let params = search_filter+'='+search_key
        //params += '&per_page=2'
        const url = api_url + '/admin/events?'+params;

        setLoading(1)
        sendRequest(url)
    }

    function clearSearch(){
        setSearchKey('')
        getEvents()
    }

    function sendRequest(url){
        httpRequest(url, "GET", {}, true)
            .then((res) => {
                setEvents(res.data);
                setResData(res);
                setLoading(0)
            })
            .catch((err) => {
                setLoading(0)
                
                //Unauthorize
                if(err.status_code === 401){
                    window.location.href = "/";
                }

                Swal.fire({
                    title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }

    function exportReport(event, data_type) {
        setLoading(1);

        const event_id = event.id;
        const url = `${api_url}/admin/reports/${event_id}/export`
        const name = event.slug;
        
        const today = new Date();
        const date = today.getFullYear() + '-' + today.getMonth() + 1+ '-' + today.getDate() + '_' +  today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds();
        const file_name = data_type + '_of_' + name + '_' + date + '.xlsx';

        
        fetch(url, {
            method: 'POST',
            headers: httpAuthHeaders(),
            body: JSON.stringify({ data: data_type })
        })
        .then((res) => {
          if(res.ok) {
            return res.blob();
          }
          
          const json = res.json();
          const status_code = res.status;
  
          if (!res.ok) {
              let errorCode = json.error_code ? json.error_code : 'unknown';
              let message = json.message ? json.message : (res.statusText ? res.statusText : 'Request failed');
              let data = json.error ? json.error: '';
              let status = json.status ? json.status: '';
              let error = { data: data, message: message, error_code: errorCode, status_code: status_code, status: status };
  
              if (status_code === 422) error = { ...error, ...json };
  
              return Promise.reject(error);
          }
        })
        .then(blob => {
            var url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.setAttribute("style", "display: none");
            a.setAttribute("href", url);
            a.download = file_name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.parentNode.removeChild(a);
            setLoading(0);
        })
        .catch(err => {
          Swal.fire("Error", "Export failed", "error");
          setLoading(0);
        });
    }

    function changeStatus(event_id, status) {
      const url = `${api_url}/admin/events/${event_id}/change-status`
      setLoading(0)

        Swal.fire({
            title: 'Please Confirm',
            html: 'Do you really want to update the staus of this event?',
            icon: 'info',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Continue',
            showCancelButton: true,
            allowOutsideClick: false
        }).then((result) => {
              if (result.isConfirmed) {
                httpRequest(url, "POST", {
                  postdata:  {
                    status: status,
                  },
                }, true)
                .then((res) => {
                    setLoading(0)

                    Swal.fire({
                        title: 'Success!',
                        text: res.message,
                        icon: 'success',
                        confirmButtonText: 'OK'
                    });

                    getEvents()
                })
                .catch((err) => {
                    setLoading(0)

                    Swal.fire({
                        title: "Error!",
                        text: err.message,
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }); 
              }
        })
    }

    function deleteEvent(event_id) {
      Swal.fire({
          title: 'Delete Event?',
          html: 'Do you really want to delete these record?<br/>All associated records will also deleted. This process cannot be undone.',
          icon: 'info',
          cancelButtonText: 'Cancel',
          //confirmButtonText: 'Detete',
          denyButtonText: 'Detete',
          showDenyButton: true,
          showCancelButton: true,
          showConfirmButton: false,
          allowOutsideClick: false
      }).then((result) => {
          if (result.isDenied) {
                setLoading(1)
                const url = `${api_url}/admin/events/${event_id}`

                httpRequest(url, "DELETE", {}, true)
                .then((res) => {
                    setLoading(0)
                    Swal.fire({
                        title: 'Success!',
                        text: res.message,
                        icon: 'success',
                        confirmButtonText: 'OK'
                    });
                })
                .catch((err) => {
                    setLoading(0)

                    Swal.fire({
                        title: "Error!",
                        text: err.message,
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }); 
          }
      })
    }

    function table_items(event_list){
        let table_items = [];
        if (Object.keys(event_list).length > 0) {
          table_items = Object.entries(event_list).map(([key, data]) => {
            return (<tr key={data.id}>
                        <td>
                          <div className="form-check">
                              <input className="form-check-input" type="checkbox" defaultValue id="flexCheckDefault" />
                          </div>
                        </td>
                        {/* <td scope="row"><Link className="link-list-events fw-bold" to={`/admin/manage/event/${data.id}/details`}>{data.title}</Link></td> */}
                        <td scope="row">{data.title}</td>
                        <td>{helpers.displayDateOnly(data)}</td>
                        <td>{helpers.displayVenue(data)}</td>
                        <td>{data.type_id.type_name}</td>
                        <td>{data.category_id.category_name}</td>
                        <td>
                            {enums.eventStatus(data.status)}
                        </td>
                        <td className='text-center'>
                            {/* <Link className="btn btn-sm btn-secondary px-2" style={{fontSize: '.7rem'}} to={`/admin/manage/event/${data.id}/transactions`}>TRANSACTION</Link> */}
                            <div>
                            <Dropdown className='custom-dropdown'>
                              <Dropdown.Toggle variant="secondary" size="sm" id={"dropdown-actions-"+key}></Dropdown.Toggle>

                              <Dropdown.Menu align="end">
                                  {displayDropItems(data)}
                              </Dropdown.Menu>
                            </Dropdown>
                            </div>
                        </td>
                    </tr>
                    )
          })
        }
        else{
          table_items = <tr>
                  <td colSpan="8" className='text-center'>No available data</td>
            </tr>
        }

        return table_items;
    }

    function displayDropItems(data){
        let items = []
        items.push(<Dropdown.Item key="view" as={Link} to={`/e/${data.slug}`}>View</Dropdown.Item>)
        items.push(<Dropdown.Item key="edit" as={Link} to={`/admin/manage/event/${data.id}/details`}>Edit</Dropdown.Item>)

        items.push(<Dropdown.Item key="transactions" as={Link} to={`/admin/manage/event/${data.id}/transactions`}>View Transactions</Dropdown.Item>)
        items.push(<Dropdown.Divider key="divider1" />)
        items.push(<Dropdown.Item key="export-trans" onClick={(e) => exportReport(data, 'transactions')}>Export Transactions</Dropdown.Item>)
        items.push(<Dropdown.Item key="export-part" onClick={(e) => exportReport(data, 'participants')}>Export Participants</Dropdown.Item>)
        items.push(<Dropdown.Divider key="divider2" />)

        if(data.status != 'cancelled' && data.status != 'postponed'){
          items.push(<Dropdown.Item key="postponed" onClick={(e) => changeStatus(data.id, 'postponed')}>Postpone</Dropdown.Item>)
          items.push(<Dropdown.Item key="cancel" onClick={(e) => changeStatus(data.id, 'cancelled')}>Cancel</Dropdown.Item>)
        }
        items.push(<Dropdown.Item key="delete" onClick={(e) => deleteEvent(data.id)} className="text-danger">Delete</Dropdown.Item>)

        return items;
    }

    return (
        <section className="faith">
        <div className="container">
        <div className="parent">
          <div className="container py-4">
            <h1>
              Admin Dashboard
            </h1>
            <SearchBar
                viewer="admin"
                search_key={search_key}
                // input_type= {input_type}
                search_filter={search_filter} 
                setSearchKey={setSearchKey} 
                // setInputType={setInputType} 
                setFilter={setFilter}
                setLoading = {setLoading}
                sendRequest = {sendRequest}
                clearSearch = {clearSearch}
                handleSearch={handleSearch}
            />

            {/* Login navigation */}
            <div className="container card filter-dashboard mx-0 px-0" style={{position: 'relative'}}>
              <Loader isLoading={loading}/>

              <nav id="events-tab" className="navigation-login d-flex justify-content-between">
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  <button className="nav-link active list-events" id="nav-all-event-tab" data-bs-toggle="tab" data-bs-target="#nav-all-event" type="button" role="tab" aria-controls="nav-all-event" aria-selected="true" onClick={(e)=>changeTab('all-events')}>Manage Events</button>
                  {/* <button className="nav-link list-events" id="nav-my-event-tab" data-bs-toggle="tab" data-bs-target="#nav-my" type="button" role="tab" aria-controls="nav-my" aria-selected="false" onClick={(e)=>changeTab('registrant')}>All Events</button> */}
                </div>
                <div className="d-flex btns">
                  <Link className="btn btn-link" to="/admin/manage/event/create"><img src={images.addIcon} /> Create Event</Link>
                  {/* <button type="button" className="btn btn-link" data-bs-toggle="modal" data-bs-target="#deleteEvent"><img src={images.deleteIcon} /> Delete</button> */}
                </div>
              </nav>
              <div className="tab-content" id="nav-tabContent">
                <div className="tab-pane fade show active px-4 pt-4" id="nav-all-event" role="tabpanel" aria-labelledby="nav-all-event-tab">
                  {/* <h4 className="faith-login-title mt-3">My Events</h4> */}
                  <div className="table-responsive">
                    <table className="table table-responsive table-hover">
                      <thead>
                        <tr>
                          <th scope="col">
                            <div className="form-check">
                              <input className="form-check-input" type="checkbox" defaultValue id="flexCheckDefault" />
                              <label className="form-check-label" htmlFor="flexCheckDefault">
                              </label>
                            </div>
                          </th>
                          <th scope="col">NAME</th>
                          <th scope="col">DATE</th>
                          <th scope="col">VENUE</th>
                          <th scope="col">TYPE</th>
                          <th scope="col">CATEGORY</th>
                          <th scope="col">STATUS</th>
                          <th scope="col">ACTION</th>
                        </tr>
                      </thead>
                      <tbody>
                            {table_items(event_list)}
                      </tbody>
                    </table>

                    <Paginations
                      current_page={res_data.current_page}
                      total_page={res_data.total}
                      per_page={res_data.per_page}
                      changePage={changePage}
                    />
                  </div>
                </div>
                
                <div className="tab-pane fade px-4" id="nav-my" role="tabpanel" aria-labelledby="nav-my-event-tab">
                  <h4 className="faith-login-title mt-3">Transactions</h4>
                  <div className="table-responsive">
                    <table className="table table-responsive table-hover">
                      <thead>
                        <tr>
                          <th scope="col">
                            <div className="form-check">
                              <input className="form-check-input" type="checkbox" defaultValue id="flexCheckDefault" />
                              <label className="form-check-label" htmlFor="flexCheckDefault">
                              </label>
                            </div>
                          </th>
                          <th scope="col">REFERENCE NO.</th>
                          <th scope="col">NAME</th>
                          <th scope="col">VENUE</th>
                          <th scope="col">TYPE</th>
                          <th scope="col">CATEGORY</th>
                          <th scope="col">STATUS</th>
                        </tr>
                      </thead>
                      <tbody>
                            {/* {table_items} */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* End Login navigation  */}
          </div>
        </div>
        </div>
        </section>
    )
}
 
export default DashboardAdmin;